export default __webpack_public_path__ + "static/media/RobotoCondensed-LightItalic.6ffc7066.ttf";